import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ScreenRegistration = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    businessName: '',
    ownerName: '',
    email: '',
    phone: '',
    address: '',
    screenSize: '',
    locationType: '',
    operatingHours: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
    alert('Registration submitted successfully! We will contact you within 24 hours.');
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-text-primary mb-4">Register Your Screen</h1>
          <p className="text-text-secondary">Join our network and start earning passive income</p>
        </div>
        
        <div className="bg-white rounded-lg shadow-card p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  Business Name
                </label>
                <input
                  type="text"
                  name="businessName"
                  value={formData.businessName}
                  onChange={handleInputChange}
                  className="w-full p-3 border border-border rounded-lg focus:border-primary focus:outline-none"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  Owner Name
                </label>
                <input
                  type="text"
                  name="ownerName"
                  value={formData.ownerName}
                  onChange={handleInputChange}
                  className="w-full p-3 border border-border rounded-lg focus:border-primary focus:outline-none"
                  required
                />
              </div>
            </div>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="w-full p-3 border border-border rounded-lg focus:border-primary focus:outline-none"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  Phone
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className="w-full p-3 border border-border rounded-lg focus:border-primary focus:outline-none"
                  required
                />
              </div>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-text-secondary mb-2">
                Business Address
              </label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                rows="3"
                className="w-full p-3 border border-border rounded-lg focus:border-primary focus:outline-none"
                required
              />
            </div>
            
            <div className="grid md:grid-cols-3 gap-6">
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  Screen Size
                </label>
                <select
                  name="screenSize"
                  value={formData.screenSize}
                  onChange={handleInputChange}
                  className="w-full p-3 border border-border rounded-lg focus:border-primary focus:outline-none"
                  required
                >
                  <option value="">Select Size</option>
                  <option value="32">32" - Small Display</option>
                  <option value="55">55" - Medium Display</option>
                  <option value="75">75" - Large Display</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  Location Type
                </label>
                <select
                  name="locationType"
                  value={formData.locationType}
                  onChange={handleInputChange}
                  className="w-full p-3 border border-border rounded-lg focus:border-primary focus:outline-none"
                  required
                >
                  <option value="">Select Type</option>
                  <option value="coffee-shop">Coffee Shop</option>
                  <option value="restaurant">Restaurant</option>
                  <option value="retail-store">Retail Store</option>
                  <option value="office-lobby">Office Lobby</option>
                  <option value="gym">Gym/Fitness Center</option>
                  <option value="medical">Medical Office</option>
                  <option value="other">Other</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  Operating Hours
                </label>
                <select
                  name="operatingHours"
                  value={formData.operatingHours}
                  onChange={handleInputChange}
                  className="w-full p-3 border border-border rounded-lg focus:border-primary focus:outline-none"
                  required
                >
                  <option value="">Select Hours</option>
                  <option value="8-12">8-12 hours/day</option>
                  <option value="12-16">12-16 hours/day</option>
                  <option value="16-20">16-20 hours/day</option>
                  <option value="24">24 hours/day</option>
                </select>
              </div>
            </div>
            
            <div className="flex gap-4 pt-6">
              <button
                type="submit"
                className="btn-primary flex-1"
              >
                Submit Registration
              </button>
              <button
                type="button"
                onClick={() => navigate('/')}
                className="border-2 border-border text-text-secondary font-semibold px-6 py-3 rounded-lg hover:bg-surface transition-all duration-250"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ScreenRegistration;